import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { UploadAddProductSliderModelService } from '../upload-add-product/upload-add-product-slider-model.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-upload-advantage-product',
  templateUrl: './upload-product.component.html',
  styleUrls: ['./upload-product.component.scss']
})
export class UploadProductComponent implements OnInit, OnDestroy {
  @ViewChild('UploadFileInput') uploadFileInput: ElementRef;

  private subscription = new Array<Subscription>();

  fileInputLabel: string;
  headerCompany = MasterConstants.US_COMPANYCODE;

  constructor(
    private _mdr: MatDialogRef<UploadProductComponent>,
    private toastrService: ToastrService,
    private loaderService: LoaderService,
    private blanketOrderService: BlanketOrderService,
    private uploadAddProductSliderModelService: UploadAddProductSliderModelService,
    @Inject(MAT_DIALOG_DATA) data: string
  ) {
  }
  CloseDialog() {
    this._mdr.close(false);
  }

  ngOnInit() {
  }

  onFileSelect(event) {
    const af = ['csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!af.includes(file.type)) {
        this.toastrService.error('Accepted formats: .xls .xlsx .csv');
      } else {
        this.fileInputLabel = file.name;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64Arr = reader.result.toString().split(',');
          const postData = {
            shipToAccount: this.uploadAddProductSliderModelService.shipToAccount,
            companyCode: this.headerCompany,
            mimeType: base64Arr[0].replace('data:', ''),
            fileName: this.fileInputLabel,
            base64: base64Arr[1]
          };

          // POST to server
          this.loaderService.setLoaderStatus(true);
          this.subscription.push(this.blanketOrderService.uploadProductExcel(postData).subscribe((result: any) => {
            this.loaderService.setLoaderStatus(false);
            if (result) {
              if (result.errorMessage) {
                this.toastrService.error(result.errorMessage);
              }
              else {
                this.uploadAddProductSliderModelService.uploadedProducts = result.uploadProducts;
                this.CloseDialog();
                this.uploadAddProductSliderModelService.activeSlider('UploadAddBlanketProductSlider');
              }
            }
          }, (error) => {
            this.loaderService.setLoaderStatus(false);
          }));
        };
        reader.onerror = function (error) {
          LolLoggerService.info(error);
        };
      }
    }
  }

  // Get getUploadTemplate()
  getUploadTemplate() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.blanketOrderService.downloadProductExcel().subscribe((result: any) => {
      this.loaderService.setLoaderStatus(false);
      if (result) {
        const link = document.createElement('a');
        link.download = result.fileName;
        link.href = 'data:application/vnd.ms-excel;base64,' + result.base64;
        link.target = '_blank';
        link.click();
      } else {
        this.toastrService.error('No Record Found.');
      }
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
